// eslint-disable-next-line @github-ui/github-monorepo/filename-convention
import {useEffect, useState} from 'react'

import {isBrowser} from './../utils/platform'

export const usePrefersReducedMotion = () => {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false)

  useEffect(() => {
    if (!isBrowser()) return
    const mediaQuery = window.matchMedia('(prefers-reduced-motion)')
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setPrefersReducedMotion(mediaQuery.matches)

    const handleChange = () => {
      setPrefersReducedMotion(mediaQuery.matches)
    }

    mediaQuery.addEventListener('change', handleChange)

    return () => {
      mediaQuery.removeEventListener('change', handleChange)
    }
  }, [])

  return prefersReducedMotion
}

export default usePrefersReducedMotion
